import comp from "./InputTextField";
export { default as FormTextInput } from "./FormTextInput";

export default comp;
